import React, { PureComponent } from 'react'
import {
  DsButton,
  DsButtonProps,
  IwithBreakpoints,
  withBreakpoints
} from '@am92/react-design-system'

interface IResponsiveButton extends DsButtonProps {}

class ResponsiveButton extends PureComponent<
  IResponsiveButton & IwithBreakpoints
> {
  render() {
    const { breakpoints, breakpointsValues, children, ref, ...restprops } =
      this.props
    const size = breakpoints.xs || breakpoints.sm ? 'large' : 'medium'

    return (
      <DsButton size={size} {...restprops}>
        {children}
      </DsButton>
    )
  }
}

export default withBreakpoints(ResponsiveButton)
